Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const core_1 = require("@emotion/core");
const styled_system_1 = require("@wheelroom/styled-system");
const merge_ncss_1 = require("../lib/merge-ncss");
const image_reset_1 = require("./image-reset");
const defaultMediaGatsbyModel = {
    description: 'No media description available',
    file: {
        url: '//placehold.it/2560',
        fileName: 'none',
        contentType: 'image/png',
    },
    fluid: {
        sizes: '(max-width: 2560px, 100vw, 2560px)',
        src: '//placehold.it/2560',
        srcSet: '',
    },
    title: 'No media title available',
};
exports.Image = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const media = props.media || defaultMediaGatsbyModel;
    if (((_a = media === null || media === void 0 ? void 0 : media.file) === null || _a === void 0 ? void 0 : _a.contentType) === 'video/ogg' ||
        ((_b = media === null || media === void 0 ? void 0 : media.file) === null || _b === void 0 ? void 0 : _b.contentType) === 'video/mp4' ||
        ((_c = media === null || media === void 0 ? void 0 : media.file) === null || _c === void 0 ? void 0 : _c.contentType) === 'video/webm') {
        return null;
    }
    const figcaption = {
        description: media.description ||
            props.description ||
            defaultMediaGatsbyModel.description,
    };
    let imgElementAttrs;
    const imgAttrs = {
        alt: media.description ||
            props.description ||
            defaultMediaGatsbyModel.description,
        title: media.title || props.title || defaultMediaGatsbyModel.title,
    };
    if (((_e = (_d = props.media) === null || _d === void 0 ? void 0 : _d.file) === null || _e === void 0 ? void 0 : _e.contentType) === 'image/jpeg' ||
        ((_g = (_f = props.media) === null || _f === void 0 ? void 0 : _f.file) === null || _g === void 0 ? void 0 : _g.contentType) === 'image/webp' ||
        ((_j = (_h = props.media) === null || _h === void 0 ? void 0 : _h.file) === null || _j === void 0 ? void 0 : _j.contentType) === 'image/png') {
        const fluidAttrs = {
            sizes: media.fluid && media.fluid.sizes,
            src: media.fluid && media.fluid.src,
            srcSet: media.fluid && media.fluid.srcSet,
        };
        imgElementAttrs = Object.assign(imgAttrs, fluidAttrs);
    }
    else {
        const fileAttrs = {
            src: ((_k = media.file) === null || _k === void 0 ? void 0 : _k.url) ||
                ((_l = media.fluid) === null || _l === void 0 ? void 0 : _l.src) + '&w=2560' || ((_m = defaultMediaGatsbyModel.file) === null || _m === void 0 ? void 0 : _m.url),
        };
        imgElementAttrs = Object.assign(imgAttrs, fileAttrs);
    }
    const pictureLabel = { ncss: { label: 'picture' } };
    const imgLabel = { ncss: { label: 'image' } };
    const figcaptionLabel = { ncss: { label: 'image-figcaption' } };
    return (core_1.jsx("picture", { css: styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([
            pictureLabel,
            image_reset_1.imagePictureReset,
            props.wheel.elementNcss.image.picture,
            props.wheel.style.picture,
        ])) },
        core_1.jsx("img", Object.assign({}, imgElementAttrs, { css: styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([
                imgLabel,
                image_reset_1.imageImgReset,
                props.wheel.elementNcss.image,
                props.wheel.style,
            ])) })),
        props.includeFigcaption && figcaption.description && (core_1.jsx("figcaption", { css: styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([
                figcaptionLabel,
                image_reset_1.imageFigcaptionReset,
                props.wheel.elementNcss.image.figcaption,
                props.wheel.style.figcaption,
            ])) }, figcaption.description))));
};
//# sourceMappingURL=image.js.map